module.exports = [{"type":"title","text":"2024-11-19"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位：新增‘一鍵反手’接口。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-11-19.json
// module id = wh3A
// module chunks = 3